module.exports = __webpack_public_path__ + "static/media/agendamenu-white.30e6ade2.svg";